import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Container from "./Container.jsx";
import axios from "axios";

import Entity from "../datasource/Entity";
import Subscriptions from "../components/Views/Subscriptions.jsx";
import { SEARCH_FIELD_TYPES, SEARCH_ERROR_MSG } from "../lib/data";
import clientConfig from "../config/client";

class SubscriptionContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("subscriptions");
        this.state = {
            ...this.state,
            loading: true,
            getParams: { ...this.globalSearch.search.subscriptions },
        };
    }

    componentDidMount = async () => {
        await this.getAuxData();
    };

    handleSearchError = (errorResp) => {
        const locale = clientConfig.locale;
        const errorFieldsArr = Object.keys(errorResp.data);
        const errorFiledsLocaleLabels = [];

        for (const key of errorFieldsArr) {
            for (const searchEntity in SEARCH_FIELD_TYPES) {
                if (SEARCH_FIELD_TYPES[searchEntity].name === key) {
                    errorFiledsLocaleLabels.push(
                        `${SEARCH_FIELD_TYPES[searchEntity].label[locale]} - ${errorResp.data[key]} `,
                    );
                }
            }
        }

        const errorMsg =
            SEARCH_ERROR_MSG.label[locale] +
            "[" +
            errorFiledsLocaleLabels +
            "]";

        return alert(errorMsg);
    };

    getAll = (params = {}) => {
        const path = this.datasource.dataPath + "/" + this.modelName;

        return axios.get(path, { params }).then((response) => response.data);
    };

    getAllItems = (params) =>
        this.getAll(params)
            .then((resData) =>
                this.setState({
                    AllItems: resData.data,
                    currentPage: resData.current_page,
                    firstPageUrl: resData.first_page_url,
                    from: resData.from,
                    loading: false,
                    lastPage: resData.last_page,
                    lastPageUrl: resData.last_page_url,
                    nextPageUrl: resData.next_page_url,
                    path: resData.path,
                    perPage: resData.per_page,
                    prevPageUrl: resData.prev_page_url,
                    to: resData.to,
                    total: resData.total,
                }),
            )
            .catch((error) => {
                this.handleSearchError(error.response);
            });

    paramsChangeHandler = (newParams) => this.getAllItems(newParams);
    setCustomLoading = (loading) =>
        this.setState((state) => ({ ...state, loading: loading }));

    render = () => {
        const fields = this.datasource.getSchemaFields();
        const routes = this.datasource.routes();
        const relationsDataSource = this.datasource.relations;

        const auxDataRoomTypes =
            this.props.auxData && this.props.auxData.room_types;

        const roomTypesShort = auxDataRoomTypes?.reduce((acc, item) => {
            acc[item.id] = item.name;
            return acc;
        }, {});

        if (this.state.error && this.state.error.status == 403) {
            return <Route render={() => <Redirect to="/hotels" replace />} />;
        }

        return (
            <Switch>
                <Route path={routes.home} exact>
                    <Subscriptions
                        title={"Подписки на номер"}
                        getAllItems={this.getAllItems}
                        editAction={this.getEditLink}
                        subscriptionsData={this.state}
                        fields={fields}
                        paramsChangeHandler={this.paramsChangeHandler}
                        globalSearch={this.globalSearch}
                        updateGlobalSearch={this.updateGlobalSearch}
                        hotelId={this.props.match.params.mainId}
                        setLoading={this.setCustomLoading}
                        roomTypesShort={roomTypesShort}
                    />
                </Route>
            </Switch>
        );
    };
}

export default SubscriptionContainer;
